/* eslint-disable @typescript-eslint/no-non-null-assertion */
import React, { useEffect, useState } from 'react';
import { LayoutBase } from '../../layouts';
import { ToolsDetails, UserForm } from '../../components/custom';
import { Box, Divider, LinearProgress, SelectChangeEvent, Typography } from '@mui/material';
import { IUser, UserServices } from '../../services/api/users/UserServices';
import { useNavigate, useParams } from 'react-router-dom';
import { useAuthContext } from '../../context';
import { ConfirmationDialog, CustomAlert } from '../../components/shared';

export const DetailsUser = () => {
    const { id } = useParams();

    const [data, setData] = useState<IUser>({
        email: '',
        login: '',
        nome: '',
        permissoes: '',
        ativo: true,
        notificacao: false,
        nivel: 'user',
        main_user: false,
        register: '',
        role: '',
        mobile_phone: '',
        senha: '',
        sector: '',
        ramal: '',
        foto: ''
    });
    const [loadin, setLoadin] = useState<boolean>(false);
    const [error, setError] = useState<boolean>(false);
    const { userData } = useAuthContext();
    const navigate = useNavigate();
    const [alertInfo, setAlertInfo] = useState<{ open: boolean; message: string; severity: 'success' | 'error' | 'warning' | 'info' }>({
        open: false,
        message: '',
        severity: 'success'
    });
    const [dialogOpen, setDialogOpen] = useState(false);
    const [passwordError, setPasswordError] = useState<boolean>(false);
    const [sendClick, setSendClick] = useState<boolean>(false);

    useEffect(() => {
        setLoadin(true);
        fetchData();
    }, [id]); 

    function verify(data: IUser): boolean {
        const isValid = (
            data.email !== '' &&
            data.login !== '' &&
            data.nome !== ''
        );
        return isValid;
    }

    const fetchData = () => {
        if (id && id !== 'novo') {
            UserServices.getById(id)
                .then((result) => {
                    if (result instanceof Error) {
                        setLoadin(false);
                        setError(true); 
                        setAlertInfo({ message: `Erro ao buscar usuário: ${result.message}`, open: true, severity: 'error' });
                    } else {
                        setLoadin(false);
                        setData(result);
                        setError(false); 
                    }
                })
                .catch(err => {
                    setLoadin(false);
                    setError(true);
                    setAlertInfo({ message: `Erro inesperado ao buscar: ${err.message || 'Verifique sua conexão.'}`, open: true, severity: 'error' });
                });
        } else {
            setLoadin(false);
            setData({
                email: '',
                login: '',
                nome: '',
                permissoes: '',
                ativo: true,
                notificacao: false,
                nivel: 'user',
                main_user: false,
                register: '',
                role: '',
                mobile_phone: '',
                senha: '',
                sector: '',
                ramal: '',
                foto: ''
            });
            setError(false); 
        }
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setPasswordError(false);
        const { name, type, checked, value } = e.target;
        const updatedValue = type === 'checkbox' ? checked : value;
        const updatedData = { ...data, [name]: updatedValue };
        setData(updatedData);
    };

    const hanldePermissionChange = (newValue: string) => {
        setData(prevData => ({
            ...prevData,
            permissoes: newValue
        }));
    };

    const handleSave = () => {
        if (sendClick) {
            return;
        }

        setSendClick(true);
        setAlertInfo({ message: '', open: false, severity: 'error' });
        const valid = verify(data);
        setError(!valid);

        if (!valid) {
            setAlertInfo({ message: 'Por favor, preencha todos os campos obrigatórios.', open: true, severity: 'warning' });
            setSendClick(false);
            return;
        }

        if (id === 'novo') {
            const password = verifyPassword(data.senha);
            if (!password) {
                setPasswordError(true);
                setAlertInfo({ message: 'A senha deve conter ao menos 5 dígitos.', open: true, severity: 'error' });
                setSendClick(false);
                return;
            }

            const newDataToSave = { ...data };
            if (userData.id_empresa) {
                newDataToSave.id_empresa = userData.id_empresa;
            } else if (!newDataToSave.id_empresa) {
                setAlertInfo({ message: 'Por favor, selecione a empresa para o novo usuário.', open: true, severity: 'warning' });
                setSendClick(false);
                return;
            }
            newDataToSave.ativo = true;

            UserServices.create(newDataToSave.id_empresa, newDataToSave)
                .then((response) => {
                    if (response instanceof Error) {
                        setAlertInfo({ message: `Erro ao salvar! Erro: ${response.message}`, open: true, severity: 'error' });
                    } else {
                        setAlertInfo({ message: 'Registro salvo', open: true, severity: 'success' });
                        setTimeout(() => {
                            navigate('/users');
                        }, 1000);
                    }
                    setSendClick(false);
                })
                .catch((error) => {
                    setAlertInfo({ message: `Erro inesperado ao salvar! ${error.message || 'Verifique sua conexão.'}`, open: true, severity: 'error' });
                    setSendClick(false);
                });
        } else { 
            UserServices.upgrade(id!, data) 
                .then((response) => {
                    if (response instanceof Error) {
                        setAlertInfo({ message: `Erro ao atualizar! Erro: ${response.message}`, open: true, severity: 'error' });
                    } else {
                        setAlertInfo({ message: 'Registro atualizado', open: true, severity: 'success' });
                        setTimeout(() => {
                            navigate('/users');
                        }, 1000);
                    }
                    setSendClick(false);
                })
                .catch((error) => {
                    setAlertInfo({ message: `Erro inesperado ao atualizar! ${error.message || 'Verifique sua conexão.'}`, open: true, severity: 'error' });
                    setSendClick(false);
                });
        }
    };

    const handleNew = () => {
        navigate('/users/detalhes/novo');
    };

    const handleDialog = () => {
        setDialogOpen(!dialogOpen);
    };

    const handleDelet = () => {
        if (userData.permissoes.includes('remove')) {
            if (id && id !== 'novo') {
                UserServices.deleteById(id)
                    .then((response) => {
                        if (response instanceof Error) {
                            setAlertInfo({ message: `Erro ao deletar! Erro: ${response.message}`, open: true, severity: 'error' });
                        } else {
                            setDialogOpen(false);
                            setAlertInfo({ message: 'Registro deletado', open: true, severity: 'success' });
                            setTimeout(() => {
                                navigate('/users');
                            }, 1000);
                        }
                    })
                    .catch((error) => {
                        setAlertInfo({ message: `Erro inesperado ao deletar! ${error.message || 'Verifique sua conexão.'}`, open: true, severity: 'error' });
                    });
            } else {
                setAlertInfo({ message: 'Não é possível deletar um usuário sem ID ou em modo de criação.', open: true, severity: 'warning' });
            }
        } else {
            setAlertInfo({ message: 'Sem permissão para a ação', open: true, severity: 'error' });
        }
    };

    const handleChangeSelect = (event: SelectChangeEvent) => {
        setData(prevData => ({
            ...prevData,
            id_empresa: event.target.value as string
        }));
    };

    function verifyPassword(password: string | undefined) {
        const isValid = password !== undefined && password.length >= 5;
        return isValid;
    }

    return (
        <LayoutBase
            tollBar={<ToolsDetails
                showSaveButton={userData.permissoes.includes('add') || userData.permissoes.includes('edit')}
                showDeletButton={userData.permissoes.includes('remove') && id !== 'novo'}
                showNewButton={userData.permissoes.includes('add')}
                showBackButton={true} 
                onClickSave={handleSave}
                onClickDelet={handleDialog}
                onClickNew={handleNew}
                disableSave={sendClick}
            />}
            title='Usuário'
        >
            <Box>
                {loadin ? (
                    <>
                        <LinearProgress />
                        <Typography variant="body2" sx={{ mt: 2, textAlign: 'center' }}>Carregando dados do usuário...</Typography>
                    </>
                ) : (
                    <>
                        <Box padding={1} marginBottom={1}>
                            <Typography variant='h6'>Ficha de usuários</Typography>
                            <Divider />
                        </Box>
                        <Box>
                            <UserForm
                                data={data}
                                handleChange={handleChange}
                                handlePermission={hanldePermissionChange}
                                error={error}
                                handleChangeSelect={handleChangeSelect}
                                passwordError={passwordError}
                            />
                        </Box>
                    </>
                )}
                {alertInfo.open &&
                    <CustomAlert
                        severity={alertInfo.severity}
                        message={alertInfo.message}
                    />
                }
                <ConfirmationDialog
                    isOpen={dialogOpen}
                    onClose={handleDialog}
                    onConfirm={handleDelet}
                    title="Confirmação de Exclusão"
                    message="Tem certeza que deseja excluir?"
                />
            </Box>
        </LayoutBase>
    );
};